export default {
  'dl, ol, ul': {
    marginTop: 0,
    paddingLeft: 0,
    fontSize: '90%',
    margin: '1.5rem 0 1.5rem 3.0rem'
  },
  dl: {
    listStyle: 'none'
  },
  ul: {
    listStyle: 'circle inside'
  },
  ol: {
    listStyle: 'decimal inside'
  },
  'dt, dd, li': {
    marginBottom: '1.0rem'
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/list.js